import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { arrayOf, string, func, bool, object, number, shape } from 'prop-types';
import ProductCard from '../ProductCard';
import { Carousel } from '../../molecules';
import ProductCardHorizontal from '../ProductCardHorizontal';
export default function ProductCarousel({
  products,
  displayMode,
  onClick,
  onMouseDown,
  onProductView,
  onChange,
  gutter,
  showInCashInfo,
  slidesPerView,
  interval,
  auto,
  showPartialNextSlide,
  transitionDuration,
  productTitleAs,
  imageAltPrefix,
  imgLazyLoading,
  imageWidth,
  imageHeight,
  showControls,
  showArrowControls,
  showRating,
  enableHover,
  showPreview,
  showDiscount,
  showOfferTimer,
  showDiscountOnlyCashInfo,
  fullHeight,
  previewAction,
  cardType,
  offerTimerProps,
  showBorder,
  showButton,
  buttonProps,
  hideOriginalPrice
}) {
  const handleCarouselChange = active => {
    const actives = Array(slidesPerView).fill().map((_, index) => products[index + active]);
    onChange(actives);
  };

  const showArrowControlsProp = showArrowControls && slidesPerView <= (products == null ? void 0 : products.length);
  const variations = {
    horizontal: ProductCardHorizontal,
    vertical: ProductCard
  };
  const Card = variations[cardType];
  return /*#__PURE__*/React.createElement(Carousel, {
    onChange: handleCarouselChange,
    slidesPerView: slidesPerView,
    gutter: gutter,
    auto: auto,
    interval: interval,
    showPartialNextSlide: showPartialNextSlide,
    transitionDuration: transitionDuration,
    isProductCarousel: true,
    showControls: showControls,
    showArrowControls: showArrowControlsProp
  }, products == null ? void 0 : products.map((product, index) => /*#__PURE__*/React.createElement(Card, _extends({}, product, {
    displayMode: displayMode,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onView: onProductView,
    showInCashInfo: showInCashInfo,
    titleAs: productTitleAs,
    fullHeight: fullHeight,
    imageAltPrefix: imageAltPrefix,
    imgLazyLoading: imgLazyLoading,
    imageWidth: imageWidth,
    imageHeight: imageHeight,
    showRating: showRating,
    showOfferTimer: showOfferTimer,
    key: `product-carousel-${product.variationId || product.id}-${index}`,
    enableHover: enableHover,
    showPreview: showPreview,
    previewAction: previewAction,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    offerTimerProps: offerTimerProps,
    showBorder: showBorder,
    showButton: showButton,
    buttonProps: buttonProps,
    hideOriginalPrice: hideOriginalPrice
  }))));
}
process.env.NODE_ENV !== "production" ? ProductCarousel.propTypes = {
  displayMode: string,
  products: arrayOf(object).isRequired,
  onChange: func,
  onClick: func,
  onMouseDown: func,
  onProductView: func,
  showInCashInfo: bool,
  showPartialNextSlide: bool,
  auto: bool,
  slidesPerView: number,
  interval: number,
  fullHeight: bool,
  transitionDuration: number,
  gutter: number,
  productTitleAs: string,
  imageAltPrefix: string,
  imgLazyLoading: bool,
  imageWidth: number,
  imageHeight: number,
  showControls: bool,
  showArrowControls: bool,
  showRating: bool,
  enableHover: bool,
  showPreview: bool,
  previewAction: func,
  showDiscount: bool,
  showDiscountOnlyCashInfo: bool,
  cardType: string,
  offerTimerProps: shape({}),
  showBorder: bool,
  showOfferTimer: bool,
  showButton: bool,
  buttonProps: shape({}),
  hideOriginalPrice: bool
} : void 0;
ProductCarousel.defaultProps = {
  displayMode: 'gallery',
  onClick: () => {},
  onMouseDown: () => {},
  onProductView: () => {},
  onChange: () => {},
  showInCashInfo: true,
  showPartialNextSlide: true,
  auto: true,
  slidesPerView: 2,
  interval: 5000,
  fullHeight: true,
  transitionDuration: 400,
  gutter: 2,
  productTitleAs: 'h2',
  imageAltPrefix: '',
  imgLazyLoading: true,
  showControls: true,
  showArrowControls: false,
  showRating: true,
  enableHover: true,
  showPreview: false,
  showDiscount: false,
  showDiscountOnlyCashInfo: false,
  previewAction: () => {},
  cardType: 'vertical',
  showBorder: false,
  showOfferTimer: false,
  showButton: false,
  buttonProps: {},
  hideOriginalPrice: false
};